import type { UseBulkBiddingViewName } from 'Components/pages/VehiclesList/FiltersHeader/BulkBidding/BulkBiddingModal/useBulkBiddingModalViewName';
import { getSnowplowEventPayload, logAnalyticsEvent } from 'Services/analytics/analytics';
import { ANALYTICS_CATEGORIES, SNOWPLOW_EVENTS } from 'Services/analytics/analytics.const';

const { BULK_BIDDING } = ANALYTICS_CATEGORIES;
const { LOAD } = SNOWPLOW_EVENTS;

export const triggerBulkBiddingModalOpened = (stage: UseBulkBiddingViewName): void => {
	const eventPayload = getSnowplowEventPayload({
		category: BULK_BIDDING,
		customData: { label: `Stage: ${stage}` },
		name: 'dlr_bulk_bidding_modal_opened',
		schemaName: LOAD.SCHEMA,
		version: LOAD.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};
